import React, { Component } from 'react'
import GoTrue from "gotrue-js"
import Footer from '../components/Footer'
import Header from '../components/Header'


const auth = new GoTrue({
  APIUrl: "https://www.englishforlibya.com/.netlify/identity",
  audience: "",
  setCookie: true
});

class PasswordReset extends Component { 
  
  state = {
    email: '',
    resetSuccess: '',
    resetError: ''
  }

  emailInput = (event) => {
    this.setState({email: event.target.value})
  }
  
  requestSubmit = (event) => {
    auth
      .requestPasswordRecovery(this.state.email)
      .then(response => this.setState( {resetSuccess: 'Reset email sent - please check your inbox' }))
      .catch(error => this.setState({ resetError: error.json.msg }))

    event.preventDefault()
  }

  
  
  render() {

    return (

        <div>
          <Header />

          <div style={{margin: 'auto', textAlign: 'center'}}>
            <h2 style={{marginTop: 20, color: '#816992'}}>Request new password</h2>
            <form style={{marginBottom: 40}} onSubmit={this.requestSubmit}>
                  
              <label>Email</label>
                <input placeholder="Email address" type="text" value={this.state.email} onChange={this.emailInput}></input>
              <br/>
                  
              <input style={{marginTop: 20}} className="purple-button" type="submit" value="Submit" />
            
            </form>
          </div>

          { (this.state.resetError.length)
            ?
            <p style={{textAlign: 'center'}} className="auth-error">{this.state.resetError}</p>
            :
            <p></p>
          }
            
          { (this.state.resetSuccess.length)
          ?
          <p style={{textAlign: 'center'}} className="auth-success">{this.state.resetSuccess}</p>
          :
          <p></p>
          }

          <Footer />

        </div>

    )
  }

}



export default PasswordReset


// WEBPACK FOOTER //
// ./src/components/PasswordReset.js